// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import NetworkContainer from 'modules/onBoarding/components/Network'

const Network = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 6 - Build Your Network | ATD`}>
      <>
        <NetworkContainer />
      </>
    </DocumentTitle>
  )
}

export default Network
